import React from 'react'
import PropTypes from 'prop-types'

import Phone from '@hixme-ui/phone'

import classes from './CarrierInformationComponent.module.scss'

const CarrierInformationComponent = ({ CarrierWebsite, CarrierCSN, GroupNumber }) => {
  if (!CarrierWebsite && !CarrierCSN && !GroupNumber) return null

  return (
    <div className={classes.root}>
      <div className={classes.item}>
        <span className={classes.label}>Carrier website</span>
        {CarrierWebsite ? (
          <a
            className={classes.link}
            href={CarrierWebsite}
            target="_blank"
            rel="noopener noreferrer"
          >
            {CarrierWebsite}
          </a>
        ) : (
          <span className={classes.empty}>No website listed</span>
        )}
      </div>
      <div className={classes.item}>
        <span className={classes.label}>Carrier Customer Service</span>
        {CarrierCSN ? (
          <span className={classes.value}>
            <Phone light number={CarrierCSN} />
          </span>
        ) : (
          <span className={classes.empty}>No phone number listed</span>
        )}
      </div>
      <div className={classes.item}>
        <span className={classes.label}>Group Number</span>
        {GroupNumber ? (
          <span className={classes.value}>{GroupNumber}</span>
        ) : (
          <span className={classes.empty}>No Group Number listed</span>
        )}
      </div>
    </div>
  )
}

CarrierInformationComponent.displayName = 'CarrierInformationComponent'
CarrierInformationComponent.propTypes = {
  CarrierWebsite: PropTypes.string,
  CarrierCSN: PropTypes.string,
  GroupNumber: PropTypes.string,
}
CarrierInformationComponent.defaultProps = {
  CarrierWebsite: '',
  CarrierCSN: '',
  GroupNumber: '',
}
export default CarrierInformationComponent
